// Package Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loading from 'components/loading/loading';
import PrivateRouteConst from 'core/common/privateRouteConstant';

// Project Imports
// const DashboardChartMapping = lazy(
//   () => import('pages/dashboardMapping/dashboardChartMapping')
// );

const Dashboard = lazy(() => import('pages/dashboard/dashboard'));
// const Dashboard = lazy(
//   () => import('pages/accounting/dashboard/accountingDashboard')
// );

const DashboardChartMappingRoute = (
  <Route path={routeName.dashboard}>
    <Route
      index
      element={
        <PrivateRoute name={[PrivateRouteConst.PAYOUTREVIEWER_DASHBOARD]}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <Dashboard />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default DashboardChartMappingRoute;
